<template>
  <button
    type="button"
    class="traceability-back-button"
    @click="$emit('click')"
  >
    <md-icon md-src="/static/images/icon-arrow-left.svg" />
    Voltar
  </button>
</template>

<script>
export default {
  name: 'TraceabilityBackButton'
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.traceability-back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border: 0;
  padding: 0;
  margin-bottom: 1rem;
  background: transparent;
  color: $theme-primary-color;
  font-family: 'Exo 2';
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;

  .md-icon {
    width: 1rem;
    height: 1rem;
    min-width: 1rem;
    min-height: 1rem;
  }
}
</style>
